import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'dashboard-search-result.dashboard-label',
		defaultMessage: 'Dashboard',
		description: 'Dashboard subtype label',
	},
});
